import { defineComponent as _defineComponent } from 'vue'
import BubbleMenu from '@/components/basics/BubbleMenu.vue';
import { DashboardRepresentation, PortfolioRepresentation } from '@/clients/dashboardapi/v2';
import { Port } from '@/modules/shared/Port';
import { computed, onMounted, ref } from 'vue';

interface Dashboard {
    name: string;
    key: string;
}

interface Portfolio {
    name: string;
    key: string;
    dashboards: Dashboard[];
}

type Emits = {
    (e: 'report', dashboardKey: string): void;
    (e: 'close'): void;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'MenuPortfolios',
  emits: ["report", "close"],
  setup(__props, { emit: emits }: { emit: ({
    (e: 'report', dashboardKey: string): void;
    (e: 'close'): void;
}), expose: any, slots: any, attrs: any }) {



const portfolios = ref<PortfolioRepresentation[]>([]);
const dashboards = ref<DashboardRepresentation[]>([]);

const portfolioItems = computed<Portfolio[]>(() => portfolios.value.map((p) => ({
    key: p.key,
    name: p.name,
    dashboards: dashboards.value
        .filter((d) => d.portfolioKey === p.key)
        .map((d) => ({
            key: d.key,
            name: d.name,
        })),
})));

async function fetchPortfolios(): Promise<void> {
    portfolios.value = await Port.portfolios.getPortfolios();
}

async function fetchDashboards(): Promise<void> {
    dashboards.value = await Port.dashboards.getDashboards();
}

function createReport(dashboardKey: string) {
    emits('report', dashboardKey);
}

function close() {
    emits('close');
}

onMounted(async () => {
    await fetchPortfolios();
    await fetchDashboards();
    Port.portfolios.onChange(() => fetchPortfolios());
    Port.dashboards.onChange(() => fetchDashboards());
});

return { __sfc: true,emits, portfolios, dashboards, portfolioItems, fetchPortfolios, fetchDashboards, createReport, close, BubbleMenu }
}

})